import React from "react";
import axios from "axios";
import { getUserData } from "redux/UserAuthentication/LoginActions";
import Admin from "layouts/Admin";
import Client from "layouts/Client";
// import ClientLayout from "layouts/Auth";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
// const root = ReactDOM.createRoot(document.getElementById("root"));
import { Provider } from "react-redux";
import store from "redux/store";
import jwtDecode from "jwt-decode";

import AuthRoute from "util/AuthRoute";
import AdminRoute from "util/AdminRoute";
import ClientRoute from "util/ClientRoute";
import Login from "views/pages/Login";
import { logoutUser } from "redux/UserAuthentication/LoginActions";
import Register from "views/pages/Register";
import McatPowerBookRegister from "views/pages/McatPowerBookRegister";
import ForgotPassword from "views/pages/ForgotPassword";
import Swal from "sweetalert2";

import { renewToken } from "redux/UserAuthentication/LoginActions";

import Home from "views/LandingPages/Home";
import PMRPrepHome from "views/LandingPages/PMRPrepHome";
import FellowshipLanding from "views/LandingPages/FellowshipLanding";
import GroupPayment from "views/pages/GroupPayment";
import GroupPricing from "views/pages/GroupPricing";
import FreeAnkiDeck from "views/pages/FreeAnkiDeck";
import DeckDownloads from "views/pages/DeckDownloads";

// import PresenceGate from "components/Messages/PresenceGate";
import AppNotifications from "components/Messages/AppNotifications";


axios.defaults.baseURL =  "https://us-central1-pmr-bank.cloudfunctions.net/api";
// axios.defaults.baseURL = "http://localhost:5002/pmr-bank/us-central1/api";  
// const FBIdToken = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJhdWQiOiJodHRwczovL2lkZW50aXR5dG9vbGtpdC5nb29nbGVhcGlzLmNvbS9nb29nbGUuaWRlbnRpdHkuaWRlbnRpdHl0b29sa2l0LnYxLklkZW50aXR5VG9vbGtpdCIsImlhdCI6MTY5MDkzNDExNSwiZXhwIjoxNjkwOTM3NzE1LCJpc3MiOiJmaXJlYmFzZS1hZG1pbnNkay13NnNoOUB0cGNkYXNoYm9hcmQuaWFtLmdzZXJ2aWNlYWNjb3VudC5jb20iLCJzdWIiOiJmaXJlYmFzZS1hZG1pbnNkay13NnNoOUB0cGNkYXNoYm9hcmQuaWFtLmdzZXJ2aWNlYWNjb3VudC5jb20iLCJ1aWQiOiJVSVV5Y3ZGaHYxUnNLSTVLS0ZSek5tQk03VVoyIn0.huWm34b1x9m6Z7ouA6wnBiKJ-Z49UVacOSN6hje90wa3hHVNUgC0r3R879tbcCmiD7GyhGRnjQWH9sBNhjTrRdDAy5iZ0yGpjwA-v8EqZDAVExNqjb76tI8qWd-lmVy-2emH1N-o90l2Qy2etyxxCF6-kWVPWX39bpmjJRXddK2u0rkhFnrQtFjqimhyE-K_eRtsDNfV-kjW2zTwpeTKymmTO5UPMhnG87NoOlydkr0nPEFvPt7jCpN5x6rv_06MmMfrP4ceJsVHv2fnY5vD3PQMaGFfNtEkNATCezs0OpUqSJ-c-08scWgbdrkWJHgeJsTQ7f9korKlucCCKLpqPA"

// localStorage.setItem('FBIdToken', FBIdToken)
// axios.defaults.headers.common['Authorization'] = "Bearer "+ FBIdToken
// store.dispatch(getUserData({handle:"aringorstudent", onLogin:true}))

// const token = localStorage.FBIdToken
// if (token){
//   const decodedToken = jwtDecode(token)
//   // console.log(new Date(decodedToken.exp * 1000))

//   if (decodedToken.exp * 1000 < Date.now()){
//       // store.dispatch(refreshUser())
//       store.dispatch(logoutUser())
//     //   window.location.reload()
//         if (!localStorage.getItem('tokenExpired')) {
//             localStorage.setItem('tokenExpired', 'true');
//             window.location.reload(); // Reload the page
//         }

//   }
//   else {
//         localStorage.removeItem('tokenExpired');
//         axios.defaults.headers.common['Authorization']=token
//         store.dispatch(getUserData({onLogin:true}))

//   }
// }

let login = false;
let isRenewing = false;
let idlePromptShown = false;
let authCheckInitialized = false;
let tokenCheckInterval = null;
let lastActivityTime = Date.now();

const IDLE_TIMEOUT = 30 * 60 * 1000;       // 30 minutes idle → show prompt
const RENEW_BEFORE_EXPIRY = 5 * 60 * 1000; // Renew 5 minutes before expiry
const TOKEN_CHECK_INTERVAL = 60 * 1000;    // Check every 1 minute

// Track user activity
const updateActivity = () => { lastActivityTime = Date.now(); };
['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'].forEach(event => {
    document.addEventListener(event, updateActivity, { passive: true });
});

const isUserIdle = () => (Date.now() - lastActivityTime) >= IDLE_TIMEOUT;

const silentRenew = () => {
  if (isRenewing) return;
  const refreshToken = localStorage.getItem("FBRefreshToken");
  if (!refreshToken) {
    store.dispatch(logoutUser());
    return;
  }
  isRenewing = true;
  store.dispatch(renewToken({ token: refreshToken }));
  // Reset flag after a short delay to allow the request to complete
  setTimeout(() => { isRenewing = false; }, 10000);
};

const showIdlePrompt = () => {
  if (idlePromptShown) return;
  idlePromptShown = true;

  Swal.fire({
    title: "Are you still there?",
    text: "Your session has been idle for 30 minutes.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Stay Connected",
    cancelButtonText: "Logout",
    allowOutsideClick: false,
    allowEscapeKey: false,
  }).then((result) => {
    idlePromptShown = false;
    if (result.isConfirmed) {
      lastActivityTime = Date.now(); // Reset idle timer
      silentRenew();
    } else {
      store.dispatch(logoutUser());
    }
  });
};

const checkTokenExpiration = () => {
  const token = localStorage.FBIdToken;

  if (!token) {
    // No token — mark unauthenticated so route guards redirect
    if (!authCheckInitialized) {
      store.dispatch({ type: 'SET_UNAUTHENTICATED' });
      authCheckInitialized = true;
    }
    return;
  }

  // Initial page load — set up session
  if (!login) {
    try {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 <= Date.now()) {
        // Token already expired on load — try to renew
        const refreshToken = localStorage.getItem("FBRefreshToken");
        if (refreshToken) {
          axios.defaults.headers.common["Authorization"] = token;
          store.dispatch(renewToken({ token: refreshToken }));
          login = true;
          if (tokenCheckInterval) clearInterval(tokenCheckInterval);
          tokenCheckInterval = setInterval(checkTokenExpiration, TOKEN_CHECK_INTERVAL);
        } else {
          localStorage.removeItem("FBIdToken");
          store.dispatch({ type: 'SET_UNAUTHENTICATED' });
          authCheckInitialized = true;
        }
      } else {
        axios.defaults.headers.common["Authorization"] = token;
        store.dispatch(getUserData({ onLogin: true }));
        login = true;
        if (tokenCheckInterval) clearInterval(tokenCheckInterval);
        tokenCheckInterval = setInterval(checkTokenExpiration, TOKEN_CHECK_INTERVAL);
      }
    } catch (e) {
      // Invalid token
      localStorage.removeItem("FBIdToken");
      localStorage.removeItem("FBRefreshToken");
      store.dispatch({ type: 'SET_UNAUTHENTICATED' });
      authCheckInitialized = true;
    }
    return;
  }

  // Session is active — periodic check
  if (isUserIdle()) {
    // User is idle for 30 min — show prompt
    showIdlePrompt();
  } else {
    // User is active — silently renew if token is near expiry
    try {
      const decodedToken = jwtDecode(token);
      const timeUntilExpiry = decodedToken.exp * 1000 - Date.now();

      if (timeUntilExpiry <= 0) {
        // Token expired but user is active — silently renew
        silentRenew();
      } else if (timeUntilExpiry <= RENEW_BEFORE_EXPIRY) {
        // Token about to expire — silently renew early
        silentRenew();
      }
    } catch (e) {
      // Token decode failed — force logout
      store.dispatch(logoutUser());
    }
  }
};

// Run initial token check on page load
checkTokenExpiration();

// When user logs in via login/signup, set up the session
store.subscribe(() => {
  const { authenticated } = store.getState().loginAuth;
  if (authenticated && !login) {
    login = true;
    const token = localStorage.FBIdToken;
    if (token) {
      axios.defaults.headers.common["Authorization"] = token;
    }
    if (tokenCheckInterval) clearInterval(tokenCheckInterval);
    tokenCheckInterval = setInterval(checkTokenExpiration, TOKEN_CHECK_INTERVAL);
  }
  // Reset login flag when user logs out so next login re-initializes
  if (!authenticated && login) {
    login = false;
    if (tokenCheckInterval) {
      clearInterval(tokenCheckInterval);
      tokenCheckInterval = null;
    }
  }
});

// Axios 401 interceptor — catch expired tokens on any API call
let isLoggingOut = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const requestUrl = error.config && error.config.url ? error.config.url : '';
      // Skip interceptor for auth-related endpoints to avoid infinite loops
      if (requestUrl.includes('/logout') || requestUrl.includes('/refreshUser') || requestUrl.includes('/login')) {
        return Promise.reject(error);
      }

      const { authenticated } = store.getState().loginAuth;
      if (authenticated && !isLoggingOut) {
        // Token expired mid-session — try to renew
        const refreshToken = localStorage.getItem("FBRefreshToken");
        if (refreshToken && !isRenewing) {
          silentRenew();
        } else if (!refreshToken) {
          isLoggingOut = true;
          store.dispatch(logoutUser());
        }
      }
    }
    return Promise.reject(error);
  }
);
// window.addEventListener('contextmenu', (e) => {
//     e.preventDefault();
// });
export class App extends React.Component {
  // componentDidMount() {
  //     const token = localStorage.FBIdToken;

  //     if (token) {
  //       const decodedToken = jwtDecode(token);

  //       if (decodedToken.exp * 1000 < Date.now()) {
  //         store.dispatch(logoutUser());
  //       } else {
  //         axios.defaults.headers.common['Authorization'] = token;
  //         store.dispatch(getUserData({ onLogin: true }));
  //       }
  //     }

  // }

  render() {
    return (
      <Provider store={store}>
        <BrowserRouter>

          {/* <PresenceGate /> */}
          <AppNotifications />

          <Switch>
            {/* <Route exact path="/">
              <Redirect to="/auth/login" />
            </Route> */}
            
            <Route exact path="/" component={PMRPrepHome}/>
            <Route exact path="/fellowship/pain-medicine" render={() => <FellowshipLanding specialtyId="pain" />} />
            <Route exact path="/fellowship/sports-medicine" render={() => <FellowshipLanding specialtyId="sports" />} />
            <Route exact path="/tpc" component={Home}/>
            <Route exact path="/group-payment/:groupOrderId" component={GroupPayment}/>
            <Route exact path="/group-pricing" component={GroupPricing}/>
            <Route exact path="/free-anki-deck" component={FreeAnkiDeck}/>
            <Route exact path="/free-anki-deck/:specialty" component={FreeAnkiDeck}/>
            <Route exact path="/downloads/:token" component={DeckDownloads}/>

            <AuthRoute exact path="/auth/login" component={Login} />
            <AuthRoute exact path="/auth/register" component={Register} />
            <AuthRoute exact path="/mcatpowerbook" component={McatPowerBookRegister} />
            
            <AuthRoute
              exact
              path="/auth/forgot-password"
              component={ForgotPassword}
            />
            {/* <Route path="/admin" render={(props) => <AdminLayout {...props} />} /> */}
            {/* <Route path="/auth" render={(props) => <AuthLayout {...props} />} /> */}
            {/* <Redirect from="/" to="/admin/index" /> */}

            <AdminRoute path="/admin" component={Admin} />

            <ClientRoute path="/client" component={Client} />
            <Route path="*">
              <div>
                <h1>404 - Page Not Found</h1>
                <p>The page you're looking for doesn't exist.</p>
              </div>
            </Route>
          </Switch>
        </BrowserRouter>
      </Provider>
    );
  }
}
export default App;
